import { Component, Inject, OnInit, ViewChild, EventEmitter} from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_228';

const stepsList = [
  { text: "1", active: false, completed: false, tooltip: 'Valor Bienes Muebles Leasing', listHelp: ['151'] },
  { text: "2", active: true, completed: false, tooltip: 'Valor Bienes Muebles No Leasing ', listHelp: ['150'] },
  { text: "3", active: false, completed: false, tooltip: 'Pregunta Actualizar Valor Bien Mueble No Leasing', listHelp: ['152'] },
  { text: "4", active: false, completed: false, tooltip: 'Valor Bienes Muebles No Leasing a Actualizar', listHelp: ['153'] }
];
const tableStructure = [
  {id: 'desc', title: 'Descripción del activo'}, 
  {id: 'valDeclarar', title: 'Valor a declarar'},
];

class ArticulosDominio {
  valor: number;
  nombre: string;
}

class Form1 {
id: number;
desc: string;
valCompra: string;
valDeclaradoAnioAnterior: string;
valReajuste: string;
art: number;
valDeclarar:string;
}
@Component({
  selector: 'app-patrimonio-muebles-modal',
  templateUrl: './patrimonio-muebles-modal.component.html',
  styleUrls: ['./patrimonio-muebles-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class PatrimonioMueblesModalComponent extends HandlerModal implements OnInit {
  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public lstArticulos: ArticulosDominio[] = [];
  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;
  mensajeTabla = "Agregue, edite o elimine sus ingresos según su realidad económica.";

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave:boolean;

  constructor(
    public dialogRef: MatDialogRef<PatrimonioMueblesModalComponent>,
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();

   /*  this.validateBtnRightActive();
    this.validateShowSave(); */
  }

  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.desc="";
    this.modelForm.valCompra="0";
    this.modelForm.valDeclaradoAnioAnterior="0";
    this.modelForm.art=0;
    this.modelForm.valDeclarar="0";
    this.modelForm.valReajuste="0"; 
    this.reloadSelArticulos();
  }
  

  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_181 == undefined){

      this.model.doc.cuerpo.cc_id_181 = []; 
      this.model.doc.cuerpo.cc_id_182 = []; 
      this.model.doc.cuerpo.cc_id_183 = [];
      this.model.doc.cuerpo.cc_id_184 = [];
      this.model.doc.cuerpo.cc_id_185 = [];
      this.model.doc.cuerpo.cs_id_152 = "0";
   
    }  
  }

  protected reloadSelArticulos(conservarArt?:boolean){//Dom 1649
    
    this.lstArticulos[0] = {valor:0,nombre:""};
    this.lstArticulos[1] = {valor:1,nombre:"Valor de compra: "+this.modelForm.valCompra};
    this.lstArticulos[2] = {valor:2,nombre:"Valor declarado año anterior: "+this.modelForm.valDeclaradoAnioAnterior};
    this.lstArticulos[3] = {valor:3,nombre:"Reajuste Art. 70: "+this.modelForm.valReajuste};
    
    if(!conservarArt)this.modelForm.art=0;
  }

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_181.length; i++){
      this.modelForm.id=i;
      this.modelForm.desc=this.model.doc.cuerpo.cc_id_181[i].v;
      this.modelForm.valCompra=this.model.doc.cuerpo.cc_id_182[i].v;
      this.modelForm.valDeclaradoAnioAnterior=this.model.doc.cuerpo.cc_id_183[i].v; 
      this.modelForm.valReajuste=this.model.doc.cuerpo.cc_id_184[i].v;
      this.modelForm.valDeclarar=this.model.doc.cuerpo.cc_id_185[i].v; 
      this.modelForm.art= this.modelForm.valDeclarar == this.modelForm.valCompra ? 1 : 
                          this.modelForm.valDeclarar == this.modelForm.valDeclaradoAnioAnterior ? 2 : 3  ;
      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }
  public editModeloDesdeForm(){
    this.model.doc.cuerpo.cc_id_181[this.modelForm.id].v=this.modelForm.desc.toString();
    this.model.doc.cuerpo.cc_id_182[this.modelForm.id].v=this.modelForm.valCompra.toString();
    this.model.doc.cuerpo.cc_id_183[this.modelForm.id].v=this.modelForm.valDeclaradoAnioAnterior.toString();
    this.model.doc.cuerpo.cc_id_184[this.modelForm.id].v=this.modelForm.valReajuste.toString();
    this.model.doc.cuerpo.cc_id_185[this.modelForm.id].v=this.modelForm.valDeclarar.toString();

  }
  public addToModeloDesdeForm(){
    let i= this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_181.push({it: i, v:this.modelForm.desc});
    this.model.doc.cuerpo.cc_id_182.push({it: i, v:this.modelForm.valCompra.toString()});
    this.model.doc.cuerpo.cc_id_183.push({it: i, v:this.modelForm.valDeclaradoAnioAnterior.toString()});
    this.model.doc.cuerpo.cc_id_184.push({it: i, v:this.modelForm.valReajuste.toString()});
    this.model.doc.cuerpo.cc_id_185.push({it: i, v:this.modelForm.valDeclarar.toString()});
  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_181.splice(index,1);
    this.model.doc.cuerpo.cc_id_182.splice(index,1);
    this.model.doc.cuerpo.cc_id_183.splice(index,1);
    this.model.doc.cuerpo.cc_id_184.splice(index,1);
    this.model.doc.cuerpo.cc_id_185.splice(index,1);


    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_181.length;i++){
      this.model.doc.cuerpo.cc_id_181[i].it=i+1;
      this.model.doc.cuerpo.cc_id_182[i].it=i+1;
      this.model.doc.cuerpo.cc_id_183[i].it=i+1;
      this.model.doc.cuerpo.cc_id_184[i].it=i+1;
      this.model.doc.cuerpo.cc_id_185[i].it=i+1;

    }
  }

  public validateFormCompleted():boolean{
    return this.modelForm.desc==undefined || this.modelForm.desc==null || this.modelForm.desc.trim()=="" ||
        this.modelForm.valCompra==undefined ||  this.modelForm.valCompra=="0" || 
        this.modelForm.valDeclaradoAnioAnterior==undefined || /* this.modelForm.valDeclaradoAnioAnterior=="0" ||  */
        this.modelForm.art==undefined || this.modelForm.art==0 
  }

  public redondearFormData(){
    this.modelForm.valCompra=this.dutilidades.redondearValorMoneda(this.modelForm.valCompra.toString(),true);
    this.modelForm.valDeclaradoAnioAnterior=this.dutilidades.redondearValorMoneda(this.modelForm.valDeclaradoAnioAnterior.toString(),true);
    this.modelForm.valReajuste=this.dutilidades.redondearValorMoneda(this.modelForm.valReajuste.toString(),true);
    this.modelForm.valDeclarar=this.dutilidades.redondearValorMoneda(this.modelForm.valDeclarar.toString(),true);

  }

  public calcularValoresForm(conservarArt?:boolean){
    this.redondearFormData();
    this.modelForm.valReajuste = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION, this.modelForm.valDeclaradoAnioAnterior, "1.1240", true);
    this.modelForm.valReajuste = this.dutilidades.redondearValorMoneda(this.modelForm.valReajuste.toString(),true);

    switch(Number(this.modelForm.art)){
      case 1:
        this.modelForm.valDeclarar = this.modelForm.valCompra;
        break;
      case 2:
        this.modelForm.valDeclarar = this.modelForm.valDeclaradoAnioAnterior;
        break;
      case 3:
        this.modelForm.valDeclarar = this.modelForm.valReajuste;
        break;
    }
    this.reloadSelArticulos(conservarArt);
  }


  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
      if (this.operacionTabla==this.OPERACION_EDITAR){
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });
        //this.editModeloDesdeForm();
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){
        this.modelForm.id = this.dataSourceBody.length;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs152();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs152();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
      this.reloadSelArticulos(true);
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  
  
  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
      case 152:
        this.operacionCs152();
        break;
    }
    if(soloEstaCasilla)return;

    //Operaciones
    let resultado = "0";
    
    //C151=C149-C153+C154+C155; 
    resultado = "0";
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA, this.model.doc.cuerpo.cs_id_149,this.model.doc.cuerpo.cs_id_153, true); 
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultado,this.model.doc.cuerpo.cs_id_154, true); 
    resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, resultado,this.model.doc.cuerpo.cs_id_155, true); 
    resultado = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_QUE, resultado, "0")?"0":resultado;
    this.model.doc.cuerpo.cs_id_151 = this.dutilidades.redondearValorMoneda(resultado,true);
    
  }

  operacionCs152(){
    let suma = "0";
    for(let i=0; i<this.dataSourceBody.length; i++){
        suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valDeclarar, suma);
    }
    this.model.doc.cuerpo.cs_id_152 = suma;

  }
 
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  


  protected controlStep(direction: DirectionType): void {
   
  }



  public closeModal(){
    //this.changeStepLocal(0);
    this.initializeTablaDesdeModelo();
    this.operacionCs152();
    this.dialogRef.close("");
  }

  public guardar(){
    this.model.doc.cuerpo.cc_id_181 = undefined;
    this.inicializeModelo();
    for(let i=0; i<this.dataSourceBody.length; i++){
      this.modelForm = this.dataSourceBody[i];
      this.addToModeloDesdeForm();
    }
    this.operacionCs152();
    console.log(this.model.doc.cuerpo);
    this.saveModel.emit(true);
    this.closeModal();

  }

  protected cleanInput(nameInput: string): void {
    if(this.modelForm[nameInput] == "0" || this.modelForm[nameInput] == "")
      this.modelForm[nameInput] = '';
  }
}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-muebles-modal/patrimonio-muebles-modal.component.ts